import { select, takeEvery } from "redux-saga/effects"
import { get, pick } from "lodash"
import { Types } from "../../actions/app/history"

export function sendIdentify(state) {
  const { user } = state

  if (!user.idHash) return

  const account = {
    id: get(state, "global.selected.accountId"),
    ...pick(get(state, "global.selected.accountMeta"), ["alias", "name", "applications"]),
  }
  const { id, alias, name } = account

  // dont add superusers to segment groups
  if (!user.isSuperuser && id != null) {
    window.analytics.group(id, account)
  }

  window.analytics.identify(user.id, {
    name: user.name,
    email: user.email,
    isSuperuser: user.isSuperuser,
    accountValue: alias,
    accountName: name,
    __akita_organization_name_property: "account_name",
    __akita_organization_id_property: "account_value",
  }, {
    Intercom: {
      user_hash: user.idHash,
    },
  })

  // Intercom's verified-user state doesn't refresh from Segment identify alone
  // when post-login routing uses { replace: true } (no page() call fires).
  if (window.Intercom) {
    window.Intercom("update", { user_hash: user.idHash })
  }
}

export function sendPage() {
  window.analytics.page()
}

export function* callAnalyticsEvent(action) {
  const { type, initial, location: locationAction } = action

  if (type === Types.IDENTIFY) {
    yield select(sendIdentify)
  } else if (!initial && locationAction?.action !== "REPLACE") {
    yield select(sendPage)
  }
}

export default function* () {
  yield takeEvery([Types.IDENTIFY, Types.NAVIGATE], callAnalyticsEvent)
}
